// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"769":"0ab84ea9","2701":"b7544633"}[chunkId] + ".chunk.css";
};